import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'
import type { MultiValueExtraFieldName } from '@shared/model'
import type { ExtraFieldMultiModel } from '../../extra-field-model.hook'

import { useListsStore } from '@shared/model'

import { useSelectConfigParser } from '../../select-config-parser.hook'
import { useExtraFieldModelMulti } from '../../extra-field-model.hook'

interface SelectChangeReasonReturn {
  name: MultiValueExtraFieldName
  placeholder: string
  model: ExtraFieldMultiModel
  options: ComputedRef<AppSelectOption[]>
  isRequired: ComputedRef<boolean>
}

export const useSelectChangeReason = (): SelectChangeReasonReturn => {
  const listsStore = useListsStore()
  const name: MultiValueExtraFieldName = 'change_tutor_reason'
  const placeholder = 'Select here'

  const model = useExtraFieldModelMulti(name)

  const {
    options,
  } = useSelectConfigParser({ name })

  const isRequired = computed(() => listsStore.getTasksKanbanConfig?.extra_fields[name]?.required || false)

  return {
    name,
    placeholder,
    model,
    options,
    isRequired,
  }
}
